class TransactionLogService {

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}/transactionslog`;

    }

    getAll(token) {
        this.user = { params: { token } };
        let self = this;
        return self.axios.get(self.baseUrl, self.user)

    }

    getOne(id, token) {
        let self = this;
        this.user = { params: { token } };
        return self.axios.get(`${self.baseUrl}/${id}`, self.user)
    }

    sendEmailRequest(id, token){
        let self = this;
        let data = Object.assign({}, { id:id, token, urlFrom: window.location.origin })
        return self.axios.post( `${self.baseUrl}/request`, data )
    }
   

}
export default TransactionLogService


// WEBPACK FOOTER //
// ./src/services/transactionLogService.js